(() => {
  const page = document.querySelector('[data-exact-august-page]');
  if (!page) return;

  const form = page.querySelector('[data-august-form]');
  const result = page.querySelector('[data-august-result]');
  const number = page.querySelector('[data-august-number]');
  const error = page.querySelector('[data-august-error]');
  const images = [...page.querySelectorAll('[data-pdf-page]')];
  const monthInput = form.elements.month;
  const dayInput = form.elements.day;
  const yearInput = form.elements.year;

  const digitSum = (value) => String(value).split('').reduce((sum, digit) => sum + Number(digit), 0);
  const reduceAbove = (value, threshold) => {
    let current = value;
    while (current > threshold) current = digitSum(current);
    return current;
  };

  const calculate = (day, month) => {
    const first = reduceAbove(day + month, 22);
    const second = reduceAbove(first + 10, 22);
    return reduceAbove(second + 8, 12);
  };

  const pageUrl = (pageNumber) => {
    const padded = String(pageNumber).padStart(2, '0');
    const template = page.dataset.pdfAssetTemplate;
    return template
      ? template.replace('page-00', `page-${padded}`)
      : `assets/august_pdf_pages/page-${padded}.webp`;
  };

  const showResult = (value) => {
    number.textContent = value;
    const firstPage = (value - 1) * 4 + 1;
    images.forEach((image, index) => {
      const pdfPage = firstPage + index;
      image.src = pageUrl(pdfPage);
      image.alt = `August 2026 personal forecast for number ${value}, page ${index + 1} of 4`;
      image.dataset.pageNumber = pdfPage;
    });
    result.hidden = false;
    requestAnimationFrame(() => result.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    error.textContent = '';
    const data = new FormData(form);
    const month = Number(data.get('month'));
    const day = Number(data.get('day'));
    const year = Number(data.get('year'));
    const date = new Date(year, month - 1, day);
    const valid = year >= 1900 && year <= new Date().getFullYear()
      && month >= 1 && month <= 12
      && day >= 1 && day <= 31
      && date.getFullYear() === year
      && date.getMonth() === month - 1
      && date.getDate() === day;
    if (!valid) {
      error.textContent = 'Please enter a valid birth date.';
      return;
    }
    showResult(calculate(day, month));
  });

  const dateInputs = [monthInput, dayInput, yearInput];
  dateInputs.forEach((input, index) => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, input.maxLength);
      const complete = input.value.length === input.maxLength;
      const value = Number(input.value);
      const valid = index === 0 ? value >= 1 && value <= 12 : index === 1 ? value >= 1 && value <= 31 : value >= 1900;
      if (complete && valid && dateInputs[index + 1]) dateInputs[index + 1].focus();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Backspace' && !input.value && dateInputs[index - 1]) dateInputs[index - 1].focus();
    });
  });

  page.querySelector('[data-august-restart]').addEventListener('click', () => {
    result.hidden = true;
    images.forEach((image) => image.removeAttribute('src'));
    form.reset();
    form.querySelector('input').focus();
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  window.LuvireAugustExact = { calculate };
})();
